import type { EdgeId } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectSelectedFirstPacketId: (s: GraphState) => EdgeId | null =
  createScopedSelector(() =>
    createSelector(
      selectPathLookupApplied,
      (s) => s.pathlookup,
      (
        pathLookupApplied,
        { pathInspector: { selectedPackets, activeNodeSn } },
      ) => {
        if (!pathLookupApplied || activeNodeSn === null) {
          return null;
        }

        const nodeSelectedPackets = selectedPackets[activeNodeSn];

        if (nodeSelectedPackets === undefined) {
          return null;
        }

        return nodeSelectedPackets.selectedIncomingPacket?.id ?? null;
      },
    ),
  );
